module.exports = __webpack_public_path__ + "img/treatments-history-desktop-en.009a7b60.jpg";